import * as tslib_1 from "tslib";
/* tslint:disable:cyclomatic-complexity */
import { ChangeDetectorRef, ElementRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { Api } from '../../../api/api';
import { DataDictionaryApi } from '../../../api/data-dictionary-api';
import { LayerApi } from '../../../api/layer-api';
import { SearchApi } from '../../../api/search-api';
import { util } from '../../../classes/util';
import { environment } from '../../../environment';
import { ESRI } from '../../../esri-loader-util';
import { GisToolsService } from '../../../services/gis-tools.service';
import { LayerService } from '../../../services/layer.service';
import { BaseComponent } from '../../base.component';
var Graphic;
var minSearchTextLength = 3;
var searchDebounceTime = 500;
var sideIndicators = { even: 1, odd: 2 };
/* tslint:disable:template-cyclomatic-complexity */
var RecordEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RecordEditorComponent, _super);
    function RecordEditorComponent(authService, layerService, layerApi, dataDictionaryApi, gisToolsService, searchApi, api, cdr, _vcr) {
        var _this = _super.call(this, _vcr) || this;
        _this.authService = authService;
        _this.layerService = layerService;
        _this.layerApi = layerApi;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.gisToolsService = gisToolsService;
        _this.searchApi = searchApi;
        _this.api = api;
        _this.cdr = cdr;
        _this._active = false;
        _this.highlightColor = 'rgba(125, 247, 229, 0.75)';
        _this.highlightMarkerSize = 16;
        _this.highlightLineColor = 'rgba(8, 120, 103, 0.90)';
        _this.highlightLineWidth = 1;
        _this.loading = false;
        _this.newOnSave = false;
        _this.selectingFromMap = false;
        _this.userPermissions = [];
        _this.availableCababilities = [];
        _this.specialRecordColumns = {};
        _this.crsSuggestions = {
            counties: [],
            routes: [],
            segments: []
        };
        _this.bridgeSearchQuery = '';
        _this.mpmsSearchQuery = '';
        _this.scmSearchQuery = '';
        _this.featureSuggestions = [];
        _this.loadingFeatureSuggestions = false;
        _this.subcategoryFeatureSuggestions = [];
        _this.loadingSubcategoryFeatureSuggestions = false;
        _this.isComplete = new EventEmitter();
        _this.selectingLatLong = new EventEmitter();
        _this.activate = function (esriLayerId, objectId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.active = true;
                        this.esriLayerId = esriLayerId;
                        this.objectId = objectId;
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(null)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        return [4 /*yield*/, this.load()];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.searchFeatures = util.debounce(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.searchFeaturesWork();
                return [2 /*return*/];
            });
        }); }, searchDebounceTime);
        _this.searchSubcategoryFeatures = util.debounce(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.searchSubcategoryFeaturesWork();
                return [2 /*return*/];
            });
        }); }, searchDebounceTime);
        _this.authService.permissions.subscribe(function (permissions) { return _this.userPermissions = permissions; });
        _this.authService.user.subscribe(function (user) { return _this.user = user; });
        var bridgeLayer = environment.layers.find(function (layer) { return layer.name === 'bridgesAll'; });
        if (bridgeLayer) {
            _this.bridgeSearchQuery = "\n                bridge: layers(id: " + bridgeLayer.id + ") {\n                    data(\n                        fieldNames: [\"BRKEY\", \"BRIDGE_ID\", \"FACILITY\", \"LOCATION\"],\n                        query: {\n                            field: \"TO_CHAR(BRKEY)\",\n                            operator: \"LIKE\",\n                            value:  $stringIds\n                        } \n                    )\n                }";
        }
        var mpmsLayer = environment.layers.find(function (layer) { return layer.name === 'mpmsProjectsAll'; });
        if (mpmsLayer) {
            _this.mpmsSearchQuery = "\n                mpms: layers(id: " + mpmsLayer.id + ") {\n                    data(\n                        fieldNames: [\"PROJECT_ID\", \"PROJECT_TITLE\"],\n                        query: {\n                            field: \"TO_CHAR(PROJECT_ID)\",\n                            operator: \"LIKE\",\n                            value:  $stringIds\n                        } \n                    )\n                }";
        }
        var scmLayer = environment.layers.find(function (layer) { return layer.name === 'stormwater'; });
        if (scmLayer) {
            _this.scmSearchQuery = "\n                scm: layers(id: " + scmLayer.id + ") {\n                    data(\n                        fieldNames: [\"SCM_ID\", \"SCM_TYPE_CODE_DESC\", \"SCM_DESCRIPTION\"],\n                        query: {\n                            field: \"SCM_ID\",\n                            operator: \"LIKE\",\n                            value:  $stringIds\n                        } \n                    )\n                }";
        }
        return _this;
    }
    Object.defineProperty(RecordEditorComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = value;
            if (!this._active) {
                this.deactivate();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordEditorComponent.prototype, "canDelete", {
        get: function () { return (this.availableCababilities.includes('DR') || this.availableCababilities.includes('OWN')); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordEditorComponent.prototype, "canInsert", {
        get: function () { return (this.availableCababilities.includes('IR') || this.availableCababilities.includes('OWN')); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordEditorComponent.prototype, "canUpdate", {
        get: function () { return (this.availableCababilities.includes('UR') || this.availableCababilities.includes('OWN')); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordEditorComponent.prototype, "isNew", {
        get: function () { return !this.objectId; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordEditorComponent.prototype, "requiredByCRS", {
        get: function () {
            var retVal = false;
            if (this.specialRecordColumns
                && this.specialRecordColumns.crs
                && (this.specialRecordColumns.crs.segBegin || this.specialRecordColumns.crs.segEnd)
                && (this.specialRecordColumns.crs.offsetBegin || this.specialRecordColumns.crs.offsetEnd)
                && (((this.specialRecordColumns.crs.segBegin && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.crs.segBegin.value)) || (this.specialRecordColumns.crs.segEnd && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.crs.segEnd.value)))
                    || ((this.specialRecordColumns.crs.offsetBegin && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.crs.offsetBegin.value)) || (this.specialRecordColumns.crs.offsetEnd && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.crs.offsetEnd.value))))) {
                retVal = true;
            }
            return retVal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordEditorComponent.prototype, "requiredByLatLong", {
        get: function () {
            var retVal = false;
            if (this.specialRecordColumns && this.specialRecordColumns.latLog
                && this.specialRecordColumns.latLog.lat && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.latLog.lat.value)
                && this.specialRecordColumns.latLog.long && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.latLog.long.value)) {
                retVal = true;
            }
            return retVal;
        },
        enumerable: true,
        configurable: true
    });
    RecordEditorComponent.prototype.deactivate = function () {
        this.esriLayerId = null;
        this.objectId = null;
        this.newOnSave = false;
        this.currentLayer = null;
        this.columnIdentifiers = null;
        this.columns = null;
        this.editableColumns = null;
        this.currentFeature = null;
        this.recordColumns = null;
        this.specialRecordColumns = null;
        this.photoData = null;
        this.error = null;
        this.success = null;
        if (this.highlightLayer) {
            this.mapViewRef.map.remove(this.highlightLayer);
            this.highlightLayer = null;
        }
    };
    RecordEditorComponent.prototype.cancel = function () {
        this.isComplete.emit({ saved: false, shouldClose: true, objectId: this.objectId, esriLayerId: this.esriLayerId });
    };
    RecordEditorComponent.prototype.load = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, dbColumns_1, data, _loop_1, this_1, i;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.success = null;
                        this.loading = true;
                        this.cdr.detectChanges();
                        return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _b.sent();
                        this.recordColumns = [];
                        this.specialRecordColumns = {};
                        this.currentFeature = null;
                        if (!this.esriLayerId) return [3 /*break*/, 8];
                        this.currentLayer = this.layerService.getEsriLayerByUniqueId(this.esriLayerId);
                        this.availableCababilities = this.currentLayer.mapcoreProps.permissions.filter(function (per) { return (_this.userPermissions.includes(per.name) || per.name === 'Owner'); }).map(function (per) { return per.action; });
                        this.columns = this.currentLayer.mapcoreProps.columns;
                        this.editableColumns = this.currentLayer.mapcoreProps.tableEditableColumns;
                        this.editableColumns.sort(function (a, b) { return a.displayOrder - b.displayOrder; });
                        this.setupRecordColumns();
                        return [4 /*yield*/, this.loadDomainValues()];
                    case 2:
                        _b.sent();
                        this.categoryChange();
                        this.subcategoryChange();
                        if (!(this.specialRecordColumns && this.specialRecordColumns.latLog && !this.highlightLayer)) return [3 /*break*/, 4];
                        if (!(this.highlightLayer == undefined)) return [3 /*break*/, 4];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: 'Record Edit' }, { hideInLegend: true, identifyEnabled: false })];
                    case 3:
                        _a.highlightLayer = _b.sent();
                        _b.label = 4;
                    case 4:
                        if (!this.objectId) return [3 /*break*/, 6];
                        dbColumns_1 = this.columns.map(function (c) { return c.name; });
                        return [4 /*yield*/, this.layerApi.getData(this.currentLayer.mapcoreProps.parentId, dbColumns_1, { field: 'OBJECTID', operator: '=', value: this.objectId.toString() })];
                    case 5:
                        data = _b.sent();
                        if (data && data.length) {
                            _loop_1 = function (i) {
                                var recordColumn = this_1.recordColumns.find(function (rc) { return rc.columnName.toLowerCase().trim() === dbColumns_1[i].toLowerCase().trim(); });
                                if (recordColumn) {
                                    recordColumn.value = recordColumn.originalValue = data[0][i];
                                    if (recordColumn.inputType === 'date' && typeof recordColumn.value === 'string' && recordColumn.value.includes('T')) {
                                        recordColumn.value = recordColumn.originalValue = recordColumn.value.slice(0, recordColumn.value.indexOf('T'));
                                    }
                                }
                            };
                            this_1 = this;
                            for (i = 0; i < data[0].length; i++) {
                                _loop_1(i);
                            }
                            this.updateFields();
                        }
                        if (this.currentLayer.type === 'map-image' && this.currentLayer.sublayers.length && this.specialRecordColumns.photo) {
                            this.currentFeature = {
                                sourceLayer: this.currentLayer.sublayers.getItemAt(0),
                                attributes: this.recordColumns.map(function (rc) { return ({
                                    columnName: rc.columnName,
                                    displayName: rc.displayName,
                                    value: rc.value
                                }); })
                            };
                        }
                        _b.label = 6;
                    case 6: return [4 /*yield*/, this.updateCRSSuggestions()];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        this.loading = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.getInputType = function (column) {
        var retVal;
        switch (column.databaseDataType) {
            case 'NUMBER':
                retVal = 'number';
                break;
            case 'DATE':
                retVal = 'date';
                break;
            default:
                retVal = 'text';
                break;
        }
        return retVal;
    };
    RecordEditorComponent.prototype.setupRecordColumns = function () {
        var e_1, _a, e_2, _b;
        var _loop_2 = function (editableColumn) {
            var matchingColumn = this_2.columns.find(function (col) { return col.name.toLowerCase().trim() === editableColumn.name.toLowerCase().trim(); });
            var inputType = this_2.getInputType(matchingColumn);
            this_2.recordColumns.push({
                displayName: matchingColumn.alias,
                columnName: matchingColumn.name,
                columnDataLength: matchingColumn.databaseDataLength,
                max: inputType === 'number' ? '9'.repeat(matchingColumn.databaseDataLength) : undefined,
                readonly: this_2.objectId ? !editableColumn.isEditable : !editableColumn.isInsertable,
                specialInputType: editableColumn.inputType ? editableColumn.inputType.name : null,
                specialInputTypeData: editableColumn.inputType ? editableColumn.inputType : null,
                inputType: inputType,
                required: editableColumn.validationType ? editableColumn.validationType.required : false,
                value: null,
                originalValue: null
            });
        };
        var this_2 = this;
        try {
            for (var _c = tslib_1.__values(this.editableColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
                var editableColumn = _d.value;
                _loop_2(editableColumn);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var specialRecordColumns = this.recordColumns.filter(function (rc) { return rc.specialInputType; });
        if (specialRecordColumns.length) {
            this.specialRecordColumns = {};
            try {
                for (var specialRecordColumns_1 = tslib_1.__values(specialRecordColumns), specialRecordColumns_1_1 = specialRecordColumns_1.next(); !specialRecordColumns_1_1.done; specialRecordColumns_1_1 = specialRecordColumns_1.next()) {
                    var specialRecordColumn = specialRecordColumns_1_1.value;
                    switch (specialRecordColumn.specialInputType) {
                        case 'photo-upload':
                            this.specialRecordColumns.photo = specialRecordColumn;
                            break;
                        case 'cty-rt-picker':
                        case 'side-ind':
                            if (!this.specialRecordColumns.crs) {
                                this.specialRecordColumns.crs = {};
                            }
                            switch (specialRecordColumn.specialInputTypeData.attr) {
                                case 'countyNumber':
                                    this.specialRecordColumns.crs.county = specialRecordColumn;
                                    break;
                                case 'routeNumber':
                                    this.specialRecordColumns.crs.route = specialRecordColumn;
                                    break;
                                case 'segmentNumberBegin':
                                    this.specialRecordColumns.crs.segBegin = specialRecordColumn;
                                    break;
                                case 'segmentNumberEnd':
                                    this.specialRecordColumns.crs.segEnd = specialRecordColumn;
                                    break;
                                case 'segmentOffset':
                                case 'segmentOffsetBegin':
                                    this.specialRecordColumns.crs.offsetBegin = specialRecordColumn;
                                    break;
                                case 'segmentOffsetEnd':
                                    this.specialRecordColumns.crs.offsetEnd = specialRecordColumn;
                                    break;
                                case 'sideInd':
                                    this.specialRecordColumns.crs.sideInd = specialRecordColumn;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        case 'lat-long-picker':
                            if (!this.specialRecordColumns.latLog) {
                                this.specialRecordColumns.latLog = {};
                            }
                            if (specialRecordColumn.specialInputTypeData.attr === 'latitude') {
                                this.specialRecordColumns.latLog.lat = specialRecordColumn;
                            }
                            else if (specialRecordColumn.specialInputTypeData.attr === 'longitude') {
                                this.specialRecordColumns.latLog.long = specialRecordColumn;
                            }
                            break;
                        case 'category-feature-picker':
                        case 'subcategory-feature-picker':
                            if (!this.specialRecordColumns.category) {
                                this.specialRecordColumns.category = {};
                            }
                            switch (specialRecordColumn.specialInputTypeData.attr) {
                                case 'category':
                                    this.specialRecordColumns.category.category = specialRecordColumn;
                                    break;
                                case 'featureId':
                                    this.specialRecordColumns.category.featureId = specialRecordColumn;
                                    break;
                                case 'subcategory':
                                    this.specialRecordColumns.category.subcategory = specialRecordColumn;
                                    break;
                                case 'subcategoryFeatureId':
                                    this.specialRecordColumns.category.subcategoryFeatureId = specialRecordColumn;
                                    break;
                                default:
                                    break;
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (specialRecordColumns_1_1 && !specialRecordColumns_1_1.done && (_b = specialRecordColumns_1.return)) _b.call(specialRecordColumns_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    RecordEditorComponent.prototype.loadDomainValues = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, nonSpecialRecordColumns, dataDictionaryData, _loop_3, nonSpecialRecordColumns_1, nonSpecialRecordColumns_1_1, recordColumn;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        nonSpecialRecordColumns = this.recordColumns.filter(function (rc) { return !rc.specialInputType; });
                        if (this.specialRecordColumns.category) {
                            if (this.specialRecordColumns.category.category) {
                                nonSpecialRecordColumns.push(this.specialRecordColumns.category.category);
                            }
                            if (this.specialRecordColumns.category.subcategory) {
                                nonSpecialRecordColumns.push(this.specialRecordColumns.category.subcategory);
                            }
                        }
                        if (!nonSpecialRecordColumns.length) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(this.currentLayer.mapcoreProps.metaTableId)];
                    case 1:
                        dataDictionaryData = _b.sent();
                        _loop_3 = function (recordColumn) {
                            var matchingColumn = dataDictionaryData.find(function (ddd) { return ddd.columnName.toLowerCase().trim() === recordColumn.columnName.toLowerCase().trim(); });
                            if (matchingColumn && matchingColumn.domainValues && matchingColumn.domainValues.length) {
                                recordColumn.domainValues = matchingColumn.domainValues.map(function (dv) { return ({
                                    name: dv.codeValue + " - " + dv.shortDescription,
                                    value: recordColumn.inputType === 'number' ? parseFloat(dv.codeValue.toString()) : dv.codeValue,
                                    description: dv.longDescription
                                }); }).sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); });
                                if (matchingColumn.columnAlias) {
                                    recordColumn.columnAlias = matchingColumn.columnAlias;
                                }
                            }
                        };
                        try {
                            for (nonSpecialRecordColumns_1 = tslib_1.__values(nonSpecialRecordColumns), nonSpecialRecordColumns_1_1 = nonSpecialRecordColumns_1.next(); !nonSpecialRecordColumns_1_1.done; nonSpecialRecordColumns_1_1 = nonSpecialRecordColumns_1.next()) {
                                recordColumn = nonSpecialRecordColumns_1_1.value;
                                _loop_3(recordColumn);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (nonSpecialRecordColumns_1_1 && !nonSpecialRecordColumns_1_1.done && (_a = nonSpecialRecordColumns_1.return)) _a.call(nonSpecialRecordColumns_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.updateFields = function () {
        this.categoryChange();
        this.setLatLongMarker();
        if (this.specialRecordColumns && this.specialRecordColumns.crs) {
            if (this.specialRecordColumns.crs.segBegin && this.specialRecordColumns.crs.offsetBegin) {
                this.updateSegmentMax(this.specialRecordColumns.crs.segBegin, this.specialRecordColumns.crs.offsetBegin);
            }
            if (this.specialRecordColumns.crs.segEnd && this.specialRecordColumns.crs.offsetEnd) {
                this.updateSegmentMax(this.specialRecordColumns.crs.segEnd, this.specialRecordColumns.crs.offsetEnd);
            }
        }
    };
    RecordEditorComponent.prototype.fileSelected = function (event) {
        var _this = this;
        var fileInput = event.target;
        this.photoData = null;
        if (fileInput && fileInput.files && fileInput.files.length) {
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                _this.photoData = e.target.result.toString();
                _this.cdr.detectChanges();
            };
            fileReader.readAsDataURL(fileInput.files[0]);
        }
        this.cdr.detectChanges();
    };
    RecordEditorComponent.prototype.startLatLongSelect = function () {
        var _this = this;
        var clickHandler = this.mapViewRef.on('click', function (event) {
            if (_this.specialRecordColumns && _this.specialRecordColumns.latLog) {
                _this.specialRecordColumns.latLog.lat.value = event.mapPoint.latitude;
                _this.specialRecordColumns.latLog.long.value = event.mapPoint.longitude;
                _this.setCRSFromLatLong().then(function () { return _this.cdr.detectChanges(); });
            }
            clickHandler.remove();
            _this.selectingFromMap = false;
            _this.selectingLatLong.emit(false);
            _this.setLatLongMarker();
            _this.cdr.detectChanges();
        });
        this.selectingFromMap = true;
        this.selectingLatLong.emit(true);
    };
    RecordEditorComponent.prototype.setLatLongMarker = function () {
        if (this.highlightLayer) {
            this.highlightLayer.graphics.removeAll();
            if (this.specialRecordColumns && this.specialRecordColumns.latLog
                && this.specialRecordColumns.latLog.lat && this.specialRecordColumns.latLog.lat.value
                && this.specialRecordColumns.latLog.long && this.specialRecordColumns.latLog.long.value) {
                this.highlightLayer.graphics.add(new Graphic({
                    geometry: {
                        type: 'point',
                        latitude: this.specialRecordColumns.latLog.lat.value,
                        longitude: this.specialRecordColumns.latLog.long.value
                    },
                    symbol: {
                        type: 'simple-marker',
                        color: this.highlightColor,
                        size: this.highlightMarkerSize,
                        style: 'circle',
                        outline: {
                            type: 'simple-line',
                            color: this.highlightLineColor,
                            width: this.highlightLineWidth,
                            style: 'solid'
                        }
                    }
                }));
            }
        }
    };
    RecordEditorComponent.prototype.updateCRSSuggestions = function (specific) {
        if (specific === void 0) { specific = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var suggestionPromises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        suggestionPromises = [];
                        if (this.specialRecordColumns && this.specialRecordColumns.crs) {
                            if (this.specialRecordColumns.crs.county && !specific) {
                                suggestionPromises.push(this.gisToolsService.getAllCounties('countyCode,name')
                                    .then(function (counties) {
                                    _this.crsSuggestions.counties = counties.map(function (county) { return ({ displayName: county.name, value: county.countyCode }); });
                                }));
                            }
                            if (this.specialRecordColumns.crs.route && this.specialRecordColumns.crs.county && (!specific || specific === 'route')) {
                                this.crsSuggestions.routes = [];
                                if (this.specialRecordColumns.crs.county.value !== null && this.specialRecordColumns.crs.county.value !== '') {
                                    suggestionPromises.push(this.gisToolsService.getStateRoutesByCountyJuris(this.specialRecordColumns.crs.county.value.toString(), [1], 'stateRouteNumber,fullName')
                                        .then(function (routes) {
                                        _this.crsSuggestions.routes = routes.map(function (route) { return ({ displayName: route.fullName, value: route.stateRouteNumber }); });
                                        _this.crsSuggestions.routes.push({ value: 'NON SR' });
                                    }));
                                }
                            }
                            if ((this.specialRecordColumns.crs.segBegin || this.specialRecordColumns.crs.segEnd) && this.specialRecordColumns.crs.county && this.specialRecordColumns.crs.route && (!specific || specific === 'seg')) {
                                this.crsSuggestions.segments = [];
                                this.segmentsMap = null;
                                if (this.specialRecordColumns.crs.county.value !== null && this.specialRecordColumns.crs.county.value !== ''
                                    && this.specialRecordColumns.crs.route.value !== null && this.specialRecordColumns.crs.route.value !== '') {
                                    suggestionPromises.push(this.gisToolsService.getSegmentsByCountyAndRoute(this.specialRecordColumns.crs.county.value.toString(), this.specialRecordColumns.crs.route.value.toString(), 'segmentNumber,segmentLength')
                                        .then(function (segments) {
                                        _this.segmentsMap = segments;
                                        _this.crsSuggestions.segments = segments.map(function (segment) { return ({ value: segment.segmentNumber }); });
                                        _this.crsSuggestions.segments.push({ value: 'NON SR' });
                                        if (_this.specialRecordColumns.crs.segBegin) {
                                            if (_this.specialRecordColumns.crs.segBegin.value && !_this.crsSuggestions.segments.some(function (seg) { return seg.value === _this.specialRecordColumns.crs.segBegin.value.toString(); })) {
                                                _this.specialRecordColumns.crs.segBegin.value = null;
                                            }
                                            _this.updateSegmentMax(_this.specialRecordColumns.crs.segBegin, _this.specialRecordColumns.crs.offsetBegin);
                                        }
                                        if (_this.specialRecordColumns.crs.segEnd) {
                                            if (_this.specialRecordColumns.crs.segEnd.value && !_this.crsSuggestions.segments.some(function (seg) { return seg.value === _this.specialRecordColumns.crs.segEnd.value.toString(); })) {
                                                _this.specialRecordColumns.crs.segEnd.value = null;
                                            }
                                            _this.updateSegmentMax(_this.specialRecordColumns.crs.segEnd, _this.specialRecordColumns.crs.offsetEnd);
                                        }
                                        _this.cdr.detectChanges();
                                    }));
                                }
                            }
                        }
                        this.loadingCrsSuggestions = specific || 'all';
                        return [4 /*yield*/, Promise.all(suggestionPromises)];
                    case 1:
                        _a.sent();
                        this.loadingCrsSuggestions = null;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.updateSegmentMax = function (seg, offset) {
        if (this.segmentsMap && seg && offset) {
            offset.max = '9'.repeat(offset.columnDataLength);
            offset.maxText = null;
            var segment = this.segmentsMap.find(function (s) { return s.segmentNumber === seg.value; });
            if (segment && segment.segmentLength) {
                offset.max = segment.segmentLength.toString();
                offset.maxText = "Max offset: " + offset.max;
            }
            this.cdr.detectChanges();
        }
    };
    RecordEditorComponent.prototype.searchFeaturesWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchText, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.featureSuggestions = [];
                        searchText = this.specialRecordColumns.category.featureId.value;
                        if (!(searchText.toString().length >= minSearchTextLength && this.searchQuery)) return [3 /*break*/, 2];
                        this.loadingFeatureSuggestions = true;
                        return [4 /*yield*/, this.searchApi.getAssetIds(this.searchQuery, searchText.toString())];
                    case 1:
                        results = _a.sent();
                        this.setSearchResults(results, this.featureSuggestions);
                        this.loadingFeatureSuggestions = false;
                        this.cdr.detectChanges();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.categoryChange = function () {
        this.searchQuery = null;
        if (this.specialRecordColumns && this.specialRecordColumns.category) {
            var featureIdCol = this.specialRecordColumns.category.featureId;
            var categoryCol_1 = this.specialRecordColumns.category.category;
            if (featureIdCol && categoryCol_1 && categoryCol_1.specialInputTypeData.featureCategories) {
                var matchingCategory = categoryCol_1.value !== null ? categoryCol_1.specialInputTypeData.featureCategories.find(function (cat) { return cat.toLowerCase().trim() === categoryCol_1.value.toString().toLowerCase().trim(); }) : null;
                featureIdCol.disabled = !matchingCategory;
                this.setSearchQuery(matchingCategory);
                if (featureIdCol.disabled) {
                    featureIdCol.value = null;
                }
            }
            if (this.specialRecordColumns.category.subcategory) {
                var subcategoryCol = this.specialRecordColumns.category.subcategory;
                subcategoryCol.filteredDomainValues = null;
                if (categoryCol_1.value) {
                    subcategoryCol.filteredDomainValues = subcategoryCol.domainValues.filter(function (dv) { return dv.description === categoryCol_1.value; });
                }
            }
        }
    };
    RecordEditorComponent.prototype.searchSubcategoryFeaturesWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var searchText, results;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.subcategoryFeatureSuggestions = [];
                        searchText = this.specialRecordColumns.category.subcategoryFeatureId.value;
                        if (!(searchText.toString().length >= minSearchTextLength && this.searchQuery)) return [3 /*break*/, 2];
                        this.loadingSubcategoryFeatureSuggestions = true;
                        return [4 /*yield*/, this.searchApi.getAssetIds(this.searchQuery, searchText.toString())];
                    case 1:
                        results = _a.sent();
                        this.setSearchResults(results, this.subcategoryFeatureSuggestions);
                        this.loadingSubcategoryFeatureSuggestions = false;
                        this.cdr.detectChanges();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.subcategoryChange = function () {
        this.searchQuery = null;
        if (this.specialRecordColumns && this.specialRecordColumns.category) {
            var featureIdCol = this.specialRecordColumns.category.subcategoryFeatureId;
            var categoryCol_2 = this.specialRecordColumns.category.subcategory;
            if (featureIdCol && categoryCol_2 && categoryCol_2.specialInputTypeData.featureSubcategories) {
                var matchingCategory = categoryCol_2.value !== null ? categoryCol_2.specialInputTypeData.featureSubcategories.find(function (cat) { return cat.toLowerCase().trim() === categoryCol_2.value.toString().toLowerCase().trim(); }) : null;
                featureIdCol.disabled = !matchingCategory;
                this.setSearchQuery(matchingCategory);
                if (featureIdCol.disabled) {
                    featureIdCol.value = null;
                }
            }
        }
    };
    RecordEditorComponent.prototype.setSearchQuery = function (matchingCategory) {
        if (matchingCategory) {
            if (matchingCategory.toLowerCase().trim().startsWith('bridge')) {
                this.searchQuery = this.bridgeSearchQuery;
            }
            else if (matchingCategory.toLowerCase().trim().startsWith('mpms')) {
                this.searchQuery = this.mpmsSearchQuery;
            }
            else if (matchingCategory.toLowerCase().trim().startsWith('semp')) {
                this.searchQuery = this.scmSearchQuery;
            }
        }
    };
    RecordEditorComponent.prototype.distinctResults = function (results) {
        var e_4, _a;
        var retVal = [];
        var _loop_4 = function (result) {
            if (!retVal.find(function (r) { return r.join() === result.join(); })) {
                retVal.push(result);
            }
        };
        try {
            for (var results_1 = tslib_1.__values(results), results_1_1 = results_1.next(); !results_1_1.done; results_1_1 = results_1.next()) {
                var result = results_1_1.value;
                _loop_4(result);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) _a.call(results_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return retVal;
    };
    RecordEditorComponent.prototype.setSearchResults = function (results, suggestionsList) {
        var e_5, _a, e_6, _b, e_7, _c;
        if (results) {
            if (results.bridge && results.bridge[0].data.length) {
                try {
                    for (var _d = tslib_1.__values(this.distinctResults(results.bridge[0].data)), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var result = _e.value;
                        suggestionsList.push({
                            displayName: "BRKEY: " + result[0] + ", BRIDGE ID: " + result[1] + ", " + result[2] + " " + result[3],
                            value: result[0].toString()
                        });
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
            }
            if (results.mpms && results.mpms[0].data.length) {
                try {
                    for (var _f = tslib_1.__values(this.distinctResults(results.mpms[0].data)), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var result = _g.value;
                        suggestionsList.push({
                            displayName: "MPMS PROJECT: " + result[0] + ", " + result[1],
                            value: result[0].toString()
                        });
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
            if (results.scm && results.scm[0].data.length) {
                try {
                    for (var _h = tslib_1.__values(this.distinctResults(results.scm[0].data)), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var result = _j.value;
                        suggestionsList.push({
                            displayName: result[0] + " (" + result[1] + "), " + result[2],
                            value: result[0].toString()
                        });
                    }
                }
                catch (e_7_1) { e_7 = { error: e_7_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_7) throw e_7.error; }
                }
            }
        }
    };
    RecordEditorComponent.prototype.save = function (asNew) {
        if (asNew === void 0) { asNew = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_8, _a, e_9, _b, e_10, _c, e_11, _d, _e, _f, column, currentDate, _g, _h, column, changedColumns, formData, removeColumn_1, _j, changedColumns_1, changedColumns_1_1, column, shouldAdd, match, saveResponse, changedColumns_2, changedColumns_2_1, column, err_1;
            return tslib_1.__generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        this.error = null;
                        this.success = null;
                        if (!this.validateInputs()) return [3 /*break*/, 9];
                        if (this.isNew || asNew) {
                            try {
                                // Set User
                                for (_e = tslib_1.__values(this.recordColumns.filter(function (rc) { return rc.specialInputType === 'current-user'; })), _f = _e.next(); !_f.done; _f = _e.next()) {
                                    column = _f.value;
                                    if (column.specialInputTypeData.attr.toLowerCase() === 'username') {
                                        column.value = this.user.emailAddress ? this.user.emailAddress.toLowerCase().endsWith('@pa.gov') ? this.user.emailAddress.split('@')[0] : this.user.emailAddress : '';
                                    }
                                    else if (column.specialInputTypeData.attr.toLowerCase() === 'userid') {
                                        column.value = this.user.id;
                                    }
                                    else {
                                        console.error('Current User column not implemented for attribute.', column.specialInputTypeData);
                                    }
                                }
                            }
                            catch (e_8_1) { e_8 = { error: e_8_1 }; }
                            finally {
                                try {
                                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                                }
                                finally { if (e_8) throw e_8.error; }
                            }
                            currentDate = new Date();
                            try {
                                for (_g = tslib_1.__values(this.recordColumns.filter(function (rc) { return rc.specialInputType === 'created-timestamp'; })), _h = _g.next(); !_h.done; _h = _g.next()) {
                                    column = _h.value;
                                    if (column.specialInputTypeData.attr.toLowerCase() === 'createdtimestamp') {
                                        column.value = currentDate.valueOf();
                                    }
                                    else if (column.specialInputTypeData.attr.toLowerCase() === 'createdtimestampyear') {
                                        column.value = currentDate.getFullYear().toString();
                                    }
                                    else {
                                        console.error('Created Timestamp column not implemented for attribute.', column.specialInputTypeData);
                                    }
                                }
                            }
                            catch (e_9_1) { e_9 = { error: e_9_1 }; }
                            finally {
                                try {
                                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                }
                                finally { if (e_9) throw e_9.error; }
                            }
                        }
                        // Set Side Indicator
                        this.updateSideInd();
                        // Set Lat/Long
                        return [4 /*yield*/, this.setLatLongFromCRS()];
                    case 1:
                        // Set Lat/Long
                        _k.sent();
                        this.cdr.detectChanges();
                        if (!this.validateInputs()) return [3 /*break*/, 9];
                        changedColumns = this.recordColumns.filter(function (rc) { return asNew || rc.value !== rc.originalValue; });
                        if (!changedColumns.length) return [3 /*break*/, 9];
                        formData = new FormData();
                        if (!(this.isNew || asNew)) return [3 /*break*/, 4];
                        if (!!this.columnIdentifiers) return [3 /*break*/, 3];
                        _j = this;
                        return [4 /*yield*/, this.gisToolsService.getAllColumnIdentifiers('name, id')];
                    case 2:
                        _j.columnIdentifiers = _k.sent();
                        _k.label = 3;
                    case 3:
                        removeColumn_1 = this.columnIdentifiers.find(function (ci) { return ci.name.toLowerCase() === 'objectid'; });
                        _k.label = 4;
                    case 4:
                        try {
                            for (changedColumns_1 = tslib_1.__values(changedColumns), changedColumns_1_1 = changedColumns_1.next(); !changedColumns_1_1.done; changedColumns_1_1 = changedColumns_1.next()) {
                                column = changedColumns_1_1.value;
                                if (column.specialInputType === 'photo-upload' && this.photoRef) {
                                    formData.append(column.columnName, this.photoRef.nativeElement.files[0], column.value.toString());
                                }
                                else {
                                    shouldAdd = true;
                                    if (removeColumn_1) {
                                        match = this.columns.find(function (c) { return c.columnIdentifierId === removeColumn_1.id; });
                                        if (!match) {
                                            match = this.columns.find(function (c) { return c.name.toLowerCase() === removeColumn_1.name.toLowerCase(); });
                                        }
                                        if (match) {
                                            shouldAdd = !(column.columnName.toLowerCase() === match.name.toLowerCase());
                                        }
                                    }
                                    if (shouldAdd) {
                                        formData.append(column.columnName, this.formatFormValue(column));
                                    }
                                }
                            }
                        }
                        catch (e_10_1) { e_10 = { error: e_10_1 }; }
                        finally {
                            try {
                                if (changedColumns_1_1 && !changedColumns_1_1.done && (_c = changedColumns_1.return)) _c.call(changedColumns_1);
                            }
                            finally { if (e_10) throw e_10.error; }
                        }
                        _k.label = 5;
                    case 5:
                        _k.trys.push([5, 7, , 8]);
                        this.saving = 'Saving';
                        return [4 /*yield*/, this.api.http2.post("recordEditor/" + environment.appId + "/" + this.currentLayer.mapcoreProps.parentId + (!asNew && !this.isNew ? "/" + this.objectId : ''), formData)];
                    case 6:
                        saveResponse = _k.sent();
                        if (saveResponse) {
                            this.isComplete.emit({ saved: true, shouldClose: !this.newOnSave, objectId: this.objectId, esriLayerId: this.esriLayerId });
                            this.success = 'Save completed successfuly';
                            if (this.newOnSave) {
                                try {
                                    for (changedColumns_2 = tslib_1.__values(changedColumns), changedColumns_2_1 = changedColumns_2.next(); !changedColumns_2_1.done; changedColumns_2_1 = changedColumns_2.next()) {
                                        column = changedColumns_2_1.value;
                                        column.value = column.originalValue;
                                    }
                                }
                                catch (e_11_1) { e_11 = { error: e_11_1 }; }
                                finally {
                                    try {
                                        if (changedColumns_2_1 && !changedColumns_2_1.done && (_d = changedColumns_2.return)) _d.call(changedColumns_2);
                                    }
                                    finally { if (e_11) throw e_11.error; }
                                }
                                if (this.specialRecordColumns && this.specialRecordColumns.photo) {
                                    this.photoData = null;
                                }
                            }
                        }
                        else {
                            this.showError('Save was not completed for an unknown reason');
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _k.sent();
                        this.showError(err_1.error || err_1.message);
                        return [3 /*break*/, 8];
                    case 8:
                        this.saving = null;
                        this.cdr.detectChanges();
                        _k.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deleteResponse, err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.error = null;
                        this.success = null;
                        if (!confirm('Are you sure you want to delete this record? This cannot be undone.')) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        this.saving = 'Deleting';
                        return [4 /*yield*/, this.api.http2.delete("recordEditor/" + environment.appId + "/" + this.currentLayer.mapcoreProps.parentId + "/" + this.objectId)];
                    case 2:
                        deleteResponse = _a.sent();
                        if (deleteResponse) {
                            this.isComplete.emit({ saved: true, shouldClose: true, objectId: this.objectId, esriLayerId: this.esriLayerId });
                            this.success = 'Delete completed successfuly';
                        }
                        else {
                            this.showError('Delete was not completed for an unknown reason');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        this.showError(err_2.error || err_2.message);
                        return [3 /*break*/, 4];
                    case 4:
                        this.saving = null;
                        this.cdr.detectChanges();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.validateInputs = function () {
        var e_12, _a;
        var retVal = true;
        if (this.inputsRef) {
            var allInputs = this.inputsRef.nativeElement.querySelectorAll('input,textarea,select');
            try {
                for (var _b = tslib_1.__values(Array.from(allInputs).reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var input = _c.value;
                    if (!input.reportValidity()) {
                        retVal = false;
                    }
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
        return retVal;
    };
    RecordEditorComponent.prototype.showError = function (message) {
        if (message.includes('ORA-')) {
            message = "DB Error: " + util.capitalize(new RegExp(/ORA-\d+: (.+[^)])/g).exec(message)[1]);
        }
        this.error = message;
        this.inputsRef.nativeElement.scrollTo(0, 0);
    };
    RecordEditorComponent.prototype.formatFormValue = function (column) {
        var retVal = null;
        if (!util.isEmptyUnsetOrWhitespace(column.value)) {
            retVal = column.value.toString();
            if (column.inputType === 'text') {
                //replace all single quotes with two single quotes to meet oracle syntax.
                retVal = retVal.replaceAll("'", "''");
                retVal = "'" + retVal + "'";
            }
            else if (column.inputType === 'date') {
                var date = typeof column.value === 'string' ? new Date(column.value + "T00:00") : new Date(column.value);
                retVal = "TO_DATE('" + date.getFullYear() + "-" + this.n2s(date.getMonth() + 1) + "-" + this.n2s(date.getDate()) + " " + this.n2s(date.getHours()) + ":" + this.n2s(date.getMinutes()) + ":" + this.n2s(date.getSeconds()) + "', 'yyyy-MM-dd HH24:mi:ss')";
            }
        }
        return retVal;
    };
    RecordEditorComponent.prototype.n2s = function (value) {
        return value.toString().padStart(2, '0');
    };
    RecordEditorComponent.prototype.updateSideInd = function () {
        if (this.specialRecordColumns && this.specialRecordColumns.crs && this.specialRecordColumns.crs.sideInd) {
            var sideIndCol_1 = this.specialRecordColumns.crs.sideInd;
            var checkAginst = this.recordColumns.find(function (rc) { return rc.columnName.toLowerCase().trim() === sideIndCol_1.specialInputTypeData.segColName.toLowerCase().trim(); });
            if (checkAginst && checkAginst.value) {
                sideIndCol_1.value = util.isEven(checkAginst.value) ? sideIndicators.even : sideIndicators.odd;
            }
        }
    };
    RecordEditorComponent.prototype.setLatLongFromCRS = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var county, route, seg, offset, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.specialRecordColumns && this.specialRecordColumns.crs && this.specialRecordColumns.latLog
                            && this.specialRecordColumns.crs.county && this.specialRecordColumns.crs.county.value
                            && this.specialRecordColumns.crs.route && this.specialRecordColumns.crs.route.value
                            && ((this.specialRecordColumns.crs.segBegin && this.specialRecordColumns.crs.segBegin.value)
                                || (this.specialRecordColumns.crs.segEnd && this.specialRecordColumns.crs.segEnd.value))
                            && ((this.specialRecordColumns.crs.offsetBegin && !util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.crs.offsetBegin.value))
                                || (this.specialRecordColumns.crs.offsetEnd && !util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.crs.offsetEnd.value)))
                            && this.specialRecordColumns.latLog.lat && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.latLog.lat.value)
                            && this.specialRecordColumns.latLog.long && util.isEmptyUnsetOrWhitespace(this.specialRecordColumns.latLog.long.value)
                            && !this.requiredByCRS)) return [3 /*break*/, 2];
                        county = this.specialRecordColumns.crs.county.value;
                        route = this.specialRecordColumns.crs.route.value;
                        seg = this.specialRecordColumns.crs.segBegin ? this.specialRecordColumns.crs.segBegin.value : this.specialRecordColumns.crs.segEnd.value;
                        offset = this.specialRecordColumns.crs.offsetBegin ? this.specialRecordColumns.crs.offsetBegin.value : this.specialRecordColumns.crs.offsetEnd.value;
                        return [4 /*yield*/, this.gisToolsService.getLatLongForOffset(county, route, seg, offset.toString())];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.specialRecordColumns.latLog.lat.value = result.latitude;
                            this.specialRecordColumns.latLog.long.value = result.longitude;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RecordEditorComponent.prototype.setCRSFromLatLong = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var county, route, lat, long, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.specialRecordColumns && this.specialRecordColumns.crs && this.specialRecordColumns.latLog
                            && this.specialRecordColumns.crs.county && this.specialRecordColumns.crs.county.value
                            && this.specialRecordColumns.crs.route && this.specialRecordColumns.crs.route.value
                            && (this.specialRecordColumns.crs.segBegin || this.specialRecordColumns.crs.segEnd)
                            && (this.specialRecordColumns.crs.offsetBegin || this.specialRecordColumns.crs.offsetEnd)
                            && this.specialRecordColumns.latLog.lat && this.specialRecordColumns.latLog.lat.value
                            && this.specialRecordColumns.latLog.long && this.specialRecordColumns.latLog.long.value
                            && !this.requiredByLatLong)) return [3 /*break*/, 2];
                        county = this.specialRecordColumns.crs.county.value.toString();
                        route = this.specialRecordColumns.crs.route.value.toString();
                        lat = this.specialRecordColumns.latLog.lat.value;
                        long = this.specialRecordColumns.latLog.long.value;
                        return [4 /*yield*/, this.gisToolsService.getOffsetForCRSLatLong(lat, long, county, route, 3000, 'segmentNumber,offset,sideIndicator')];
                    case 1:
                        result = _a.sent();
                        if (result && result.length) {
                            if (this.specialRecordColumns.crs.segBegin) {
                                this.specialRecordColumns.crs.segBegin.value = result[0].segmentNumber;
                            }
                            else {
                                this.specialRecordColumns.crs.segEnd.value = result[0].segmentNumber;
                            }
                            if (this.specialRecordColumns.crs.offsetBegin) {
                                this.specialRecordColumns.crs.offsetBegin.value = parseInt(result[0].offset, 10);
                            }
                            else {
                                this.specialRecordColumns.crs.offsetEnd.value = parseInt(result[0].offset, 10);
                            }
                        }
                        else {
                            if (this.specialRecordColumns.crs.segBegin) {
                                this.specialRecordColumns.crs.segBegin.value = null;
                            }
                            else {
                                this.specialRecordColumns.crs.segEnd.value = null;
                            }
                            if (this.specialRecordColumns.crs.offsetBegin) {
                                this.specialRecordColumns.crs.offsetBegin.value = null;
                            }
                            else {
                                this.specialRecordColumns.crs.offsetEnd.value = null;
                            }
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    return RecordEditorComponent;
}(BaseComponent));
export { RecordEditorComponent };
